// store.js
import { createStore } from "redux";
import rootReducer from "Pages/AdministratorDashboard/Services/Reducers/reducers";

const store = createStore(rootReducer);

export default store;
